import React, { useState } from "react";
import img from "../../assets/images/contactusImg.webp";
import { Nav } from "../../layouts/navbar/nav";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaRegClock } from "react-icons/fa";
import "./style.css";
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { useTranslation } from "react-i18next";
import Header from "../../layouts/header";

export default function ContactUs() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    // <div className="bg-white bg-opacity-[87%] shadow-custom min-h-full flex flex-col  items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-16">
    <div className="bg-white shadow-custom bg-opacity-[87%] min-h-[50vh] md:h-full lg:h-full  flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
      <div className="text-3xl md:text-4xl font-bold text-center mb-6">
        <p>{t("contact_us.title")}</p>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex justify-center items-center flex-wrap gap-2">
          <FaLinkedin size={35} className="linkicon iconsty" />
          <FaInstagram size={35} className="instaicon iconsty" />
          <FaTiktok size={30} className="tikicon iconsty" />
          <FaYoutube size={35} className="ytbicon iconsty" />
        </div>
        <p className="px-6 md:px-[10rem] text-center text-[#5a5a5a] text-lg md:text-[20px] karla-font leading-relaxed tracking-wide">
          {t("contact_us.p1")}
        </p>
      </div>

      <div className="flex flex-col gap-4 justify-center items-center text-center">
        <FaLocationDot size={35} className="iconsty" />
        <p className="px-6 md:px-[10rem] text-[#5a5a5a] text-lg md:text-[20px] karla-font leading-relaxed tracking-wide">
          {t("contact_us.loca.p1")} <span>{t("contact_us.loca.p2")}</span>
        </p>
      </div>

      <div className="flex flex-col gap-4 justify-center items-center text-center">
        <FaRegClock size={35} className="iconsty" />
        <p className="px-6 md:px-[10rem] text-[#5a5a5a] text-lg md:text-[20px] karla-font leading-relaxed tracking-wide">
          {t("contact_us.time.p1")} <span>{t("contact_us.time.p2")}</span>
        </p>
      </div>

      <div className="flex flex-col gap-4 justify-center items-center text-center">
        <p className="px-6 md:px-[10rem] text-[#5a5a5a] text-lg md:text-[20px] karla-font leading-relaxed tracking-wide">
          <span className="flex flex-col md:flex-row justify-center items-center gap-2">
            <FaPhone size={20} className="iconsty" />
            <div>
              {t("contact_us.phone")}:{" "}
              <a
                href=""
                target="_blank"
                className="cursor-pointer font-semibold text-[#00573f] hover:text-blue-500"
              >
                (+212) 668 942 099
              </a>
            </div>
          </span>
          <span className="flex flex-col md:flex-row justify-center items-center gap-2">
            <IoMdMail size={20} className="iconsty" />
            <div>
              Email:{" "}
              <a
                href=""
                target="_blank"
                className="cursor-pointer font-semibold text-[#00573f] hover:text-blue-500"
              >
                contact@golftripsmorocco.com
              </a>
            </div>
          </span>
        </p>
      </div>

      <div className="flex flex-col gap-4 justify-center items-center"></div>
    </div>
  );
}
